import Record   from 'lib/record'
import TeamGIFS from 'config/team_gifs'

const Team = Record({
  name  : 'Unknowable',
  score : 0
}, {
  idAttribute: 'name'
})

Team.getGif = function (team) {
  let pool = TeamGIFS[team.name]

  return pool ? pool[pool.length * Math.random() | 0] : null
}


export default Team



/** WEBPACK FOOTER **
 ** ./web/static/app/records/team.js
 **/